import React from 'react';
import brandLogo from '../../assets/logo.png';

const CHART_BARS = [
  { h: 28, label: '03-10' },
  { h: 46, label: '11-18' },
  { h: 34, label: '19-25' },
  { h: 62, label: '26-02' },
  { h: 40, label: '03-10' },
  { h: 72, label: '11-18' },
  { h: 38, label: '19-25' },
  { h: 54, label: '26-02' },
];

export function AuthBrand() {
  return (
    <div className="ln-brand">
      <img src={brandLogo} alt="MoneyEU" className="ln-brand-logo" />
    </div>
  );
}

export function AuthVisual() {
  return (
    <aside className="ln-visual" aria-hidden="true">
      <div className="ln-visual-glow" />
      <h2 className="ln-visual-title">
        <span>Move money smarter.</span>
            <strong>Quickly. Globally.</strong>
      </h2>

      <div className="ln-visual-stage">
        <div className="ln-phone">
          <div className="ln-phone-status">
            <span>9:41</span>
            <span className="ln-phone-status-icons">
              <svg viewBox="0 0 18 12" width="16" height="11">
                <path d="M1 8.5h1.6V11H1V8.5zm3.2-2.5h1.6V11H4.2V6zm3.2-2.2h1.6V11H7.4V3.8zM10.6 1h1.6v10h-1.6V1z" fill="currentColor" />
              </svg>
              <svg viewBox="0 0 16 12" width="15" height="11">
                <path d="M8 2.2c2.4 0 4.6.9 6.3 2.4l-.9.9A7.4 7.4 0 0 0 8 3.6 7.4 7.4 0 0 0 2.6 5.5l-.9-.9A9.8 9.8 0 0 1 8 2.2zm0 3.2c1.5 0 2.9.6 3.9 1.5l-.9.9A4.2 4.2 0 0 0 8 6.8a4.2 4.2 0 0 0-3 .9l-.9-.9A5.7 5.7 0 0 1 8 5.4zm0 3.2a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2z" fill="currentColor" />
              </svg>
              <svg viewBox="0 0 25 12" width="24" height="11">
                <rect x="0.6" y="0.6" width="20" height="10.8" rx="2.4" stroke="currentColor" fill="none" strokeWidth="1.2" />
                <rect x="2.2" y="2.2" width="14.2" height="7.6" rx="1.2" fill="currentColor" />
                <path d="M22.2 4.2v3.6c.8-.4 1.2-1.1 1.2-1.8s-.4-1.4-1.2-1.8z" fill="currentColor" />
              </svg>
            </span>
          </div>

          <div className="ln-phone-balance-row">
            <div>
              <p className="ln-phone-kicker">Your balance</p>
              <p className="ln-phone-balance">€32,485.95</p>
            </div>
            <span className="ln-phone-bell">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path d="M12 22a2.4 2.4 0 0 0 2.4-2.4h-4.8A2.4 2.4 0 0 0 12 22zm7.2-6V10.6A7.2 7.2 0 0 0 13.2 3.5V2.8a1.2 1.2 0 1 0-2.4 0v.7A7.2 7.2 0 0 0 4.8 10.6V16L3 17.8v.9h18v-.9L19.2 16z" fill="currentColor" />
              </svg>
            </span>
          </div>

          <div className="ln-phone-card">
            <div className="ln-phone-card-top">
              <span className="ln-phone-chip" />
              <svg className="ln-phone-contactless" viewBox="0 0 24 24" width="22" height="22">
                <path d="M8.2 8.2a6.5 6.5 0 0 1 0 7.6M12 5.8a9.4 9.4 0 0 1 0 12.4M15.8 3.4a12.4 12.4 0 0 1 0 17.2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
            </div>
            <p className="ln-phone-pan">4950&nbsp;&nbsp;4820&nbsp;&nbsp;4749&nbsp;&nbsp;5702</p>
            <div className="ln-phone-card-foot">
              <span />
              <span className="ln-phone-mc">
                <i />
                <i />
              </span>
            </div>
          </div>

          <div className="ln-phone-ops">
            <div className="ln-phone-ops-head">
              <span>Operations</span>
              <span>Last month ▾</span>
            </div>
            <div className="ln-phone-ops-grid">
              <div>
                <strong>€12,958</strong>
                <em className="is-up">+8% processed</em>
              </div>
              <div>
                <strong>€2,654</strong>
                <em className="is-down">-17% payouts</em>
              </div>
            </div>
            <div className="ln-phone-progress">
              <span />
            </div>
          </div>
        </div>

        <div className="ln-float-chip">
          <span className="ln-float-toggle" />
          <div className="ln-float-copy">
            <strong>MoneyEU Business</strong>
            <span>4950 •••• •••• 5702</span>
          </div>
          <span className="ln-float-chevron">›</span>
        </div>

        <div className="ln-float-chart">
          <div className="ln-float-chart-tip">3,348.40</div>
          <div className="ln-float-chart-bars">
            {CHART_BARS.map((bar, i) => (
              <span
                key={`${bar.label}-${i}`}
                className={i === 5 ? 'is-peak' : undefined}
                style={{ height: `${bar.h}px` }}
              />
            ))}
          </div>
          <div className="ln-float-chart-labels">
            {CHART_BARS.filter((_, i) => i % 2 === 0).map((bar, i) => (
              <span key={`${bar.label}-l-${i}`}>{bar.label}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="ln-partners">
        <span>
          <svg viewBox="0 0 16 16" width="14" height="14"><rect x="2" y="4" width="12" height="8.5" rx="1.6" fill="none" stroke="currentColor" strokeWidth="1.4" /><path d="M2 6.4h12" stroke="currentColor" strokeWidth="1.4" /></svg>
          Payments
        </span>
        <span>
          <svg viewBox="0 0 16 16" width="14" height="14"><path d="M3 8h10M9.5 4.5 13 8l-3.5 3.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
          Payouts
        </span>
        <span>
          <svg viewBox="0 0 16 16" width="14" height="14"><path d="M5.2 11.2A4.2 4.2 0 1 1 8 3.8M10.8 4.8A4.2 4.2 0 1 1 8 12.2" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /><path d="M7.1 6.4h1.6c.6 0 1.1.4 1.1 1s-.5 1-1.1 1H7.4c-.6 0-1.1.4-1.1 1s.5 1 1.1 1H9M8 5.2v1.2M8 10.6v1.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>
          FX
        </span>
        <span>
          <svg viewBox="0 0 16 16" width="14" height="14"><rect x="3" y="3.2" width="10" height="9.6" rx="1.6" fill="none" stroke="currentColor" strokeWidth="1.4" /><path d="M5.2 6.4h5.6M5.2 8.8h3.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>
          Checkout
        </span>
        <span>
          <svg viewBox="0 0 16 16" width="14" height="14"><circle cx="8" cy="8" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.4" /><ellipse cx="8" cy="8" rx="2.3" ry="5.5" fill="none" stroke="currentColor" strokeWidth="1.2" /><path d="M2.5 8h11" stroke="currentColor" strokeWidth="1.2" /></svg>
          Worldwide
        </span>
      </div>
    </aside>
  );
}

export function AuthShell({
  children,
  wide = false,
}: {
  children: React.ReactNode;
  wide?: boolean;
}) {
  return (
    <div className="ln-root">
      <AuthVisual />
      <section className={`ln-form-col${wide ? ' ln-form-col--wide' : ''}`}>
        <div className={`ln-form-inner${wide ? ' ln-form-inner--wide' : ''}`}>{children}</div>
      </section>
    </div>
  );
}
